define('entities/admin/notifications',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational',
  'entities/product_translation'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  /**
   * Model
   */
  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.Notification = Backbone.RelationalModel.extend({
    defaults: {
      refUserpid: null
    },

    url: function () {
      return Settings.url('compuzz2', 'v2/usernotifications/' + this.get('secId'));
    },

    postUrl: function () {
      return Settings.url('compuzz2', 'v2/usernotifications');
    },

    fetch: function () {
      this.url = Settings.url('compuzz2', 'v2/usernotifications/' + this.get('secId'));
      return Backbone.Model.prototype.fetch.call(this);
    },

    save: function () {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    },

    read: function () {
      var defer = $.Deferred();

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'v2/usernotifications/'+ this.get('secId') +'/read'),
        success: _.bind(function (resp) {
          this.set('read', resp.read);
          defer.resolve();
        }, this)
      });

      return defer.promise();
    },

    idAttribute: 'secId',

    relations: []
  });

  var NotificationCollection = Backbone.Collection.extend({
    url: function () {
      return Settings.url('compuzz2', 'v2/tasks');
    },
    model: app.ns.Notification
  });

  /**
   * REST API
   */
  var API = {
    getRowCountUrl: function () {
      return 'v2/usernotifications/rowCount';
    },

    getNotificationsUrl: function (params) {
      return Settings.url('compuzz2', 'v2/usernotifications', params);
    },

    getNotificationsCount: function (params) {
      var defer = $.Deferred();

      $.ajax({
        url: Settings.url('compuzz2', 'v2/usernotifications/rowCount', params),
        success: function (resp) {
          defer.resolve(resp);
        }
      });

      return defer.promise();
    },

    getNotifications: function (first, pageSize) {
      var notifications = new NotificationCollection({}),
        defer = $.Deferred(),
        params = {
          first: first,
          pageSize: pageSize
        };

      notifications.url = Settings.url('compuzz2', 'v2/usernotifications/', params);
      notifications.fetch({
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    },

    readAll: function () {
      var defer = $.Deferred();

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'v2/usernotifications/readAll'),
        success: function (resp) {
          defer.resolve(resp);
        }
      });

      return defer.promise();
    },

    readAllByKey: function (notificationKey) {
      var defer = $.Deferred();

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'v2/usernotifications/readAllByKey/' + notificationKey),
        success: function (resp) {
          defer.resolve(resp);
        }
      });

      return defer.promise();
    },

    getNotificationPreferences: function () {
      var defer = $.Deferred();

      var params = {};

      $.ajax({
        url: Settings.url('compuzz2', 'v2/usernotifications/preferences', params),
        success: function (resp) {
          defer.resolve(resp);
        }
      });

      return defer.promise();
    }
  };



  App.reqres.setHandler('notifications:model', function (notificationJSON) {
    var tt;
    if (notificationJSON) {
      tt = Backbone.Relational.store.find(app.ns.Task, notificationJSON.secId);
    }
    if (tt) {
      return tt;
    } else {
      return new app.ns.Task(notificationJSON);
    }
  });

  App.reqres.setHandler('notifications:row-count-url', function () {
    return API.getRowCountUrl();
  });

  App.reqres.setHandler('notifications:get-url', function (params) {
    return API.getNotificationsUrl(params);
  });

  App.reqres.setHandler('notifications:count', function () {
    var params = {
        read: false.toString()
    };
    return API.getNotificationsCount(params);
  });

  App.reqres.setHandler('notifications:entities', function (first = 0, pageSize = 10) {
    return API.getNotifications(first, pageSize);
  });

  App.reqres.setHandler('notifications:read-all', function () {
    return API.readAll();
  });

  App.reqres.setHandler('notifications:read-all-by-key', function (notificationKey) {
    return API.readAllByKey(notificationKey);
  });

  App.reqres.setHandler('notifications:model', function (data) {
    return app.ns.Notification.findOrCreate(data);
  });

  App.reqres.setHandler('notifications:get-preferences', function () {
    return API.getNotificationPreferences();
  });

  // Add this to your App requests
  App.reqres.setHandler('notifications:save-preferences', function(preferences) {
    var defer = $.Deferred();

    $.ajax({
      url: Settings.url('compuzz2', 'v2/usernotifications/preferences'),
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(preferences),
      success: function(resp) {
        defer.resolve(resp);
      },
      error: function(xhr, status, error) {
        defer.reject(xhr, status, error);
      }
    });

    return defer.promise();
  });


});
